import { Navigate } from 'react-router-dom'
import { AuthContext } from '../context/AuthContext'
import { useContext } from 'react'
import LoadingPage from '@components/loading/LoadingPage'

const ProtectedRoute: React.FC<{
    children: React.ReactNode
    role: number[] | undefined
}> = ({ children, role }) => {
    const { checkRole, isAuthenticated, isLoading } = useContext(AuthContext)

    if (isLoading === true) {
        return <LoadingPage />
    }

    if (!isAuthenticated || !checkRole(role)) return <Navigate to={'/login'} />

    return <>{children}</>
}

export default ProtectedRoute
